import React, { memo } from 'react';
import { useLangFile } from '../../../../context/LanguageContext';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import BackspaceIcon from '@mui/icons-material/Backspace';
import Tooltip from '@mui/material/Tooltip';

interface BulkPrescriptionReturnToOverviewButtonProps {
  onClick: () => void;
}

const BulkPrescriptionReturnToOverviewButton: React.FC<
  BulkPrescriptionReturnToOverviewButtonProps
> = ({ onClick }) => {
  const LangFile = useLangFile();

  return (
    <Box
      sx={{
        ml: 1,
      }}
    >
      <Tooltip title={LangFile.BulkPrescriptionReturnToOverviewButton.label}>
        <Button variant={'outlined'} onClick={onClick}>
          <BackspaceIcon />
          <Box
            sx={{
              ml: 1,
            }}
          >
            {LangFile.BulkPrescriptionReturnToOverviewButton.label}
          </Box>
        </Button>
      </Tooltip>
    </Box>
  );
};

export default memo(BulkPrescriptionReturnToOverviewButton);
